import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsExpoComponent } from './simple-icons-expo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsExpoComponent ],
    exports:      [ SimpleIconsExpoComponent ],
    bootstrap:    []
})
export class SimpleIconsExpoModule {}
